import { Tag } from '@ads/components-react';
import { useTranslation } from 'react-i18next';

import { EActivityType } from '../../../types/gradeConfig';

/** Mapeia o tipo de atividade ao `status` do `Tag` do ADS. */
const TYPE_STATUS: Record<EActivityType, 'default' | 'highlight' | 'positive' | 'helper'> = {
  [EActivityType.Discipline]: 'default',
  [EActivityType.FinalWorkStage]: 'highlight',
  [EActivityType.FinalExam]: 'helper',
  [EActivityType.FinalWork]: 'positive',
};

export interface TypeTagProps {
  readonly type: EActivityType;
}

/**
 * Tag de tipo de vínculo (Disciplina / Etapa do trabalho final / Prova Final /
 * Trabalho final), mapeando o tipo ao tom correspondente do `Tag` do ADS.
 */
export function TypeTag({ type }: TypeTagProps) {
  const { t } = useTranslation('gradeAttendanceConfig');
  return (
    <Tag
      label={t(`types.${type}.label`)}
      status={TYPE_STATUS[type]}
      size="sm"
      custom={{ text: 'text-nowrap' }}
    />
  );
}
